import React from 'react';
import { type EntryPointProps, graphql, usePreloadedQuery } from 'react-relay';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import type { UserSegmentationRedirectEntryQuery } from './__generated__/UserSegmentationRedirectEntryQuery.graphql';
import UserSegmentationRedirect from './UserSegmentationRedirect.tsx';

type Queries = {
	userSegQueryRef: UserSegmentationRedirectEntryQuery;
};

const UserSegmentationRedirectEntry = ({
	queries: { userSegQueryRef },
}: EntryPointProps<Queries, {}, {}, {}>): React.JSX.Element | null => {
	/**
	 * ⚠️ This is just temporary redirect logic used for testing
	 * while awaiting the implementation of a new query
	 */
	const queryRef = usePreloadedQuery<UserSegmentationRedirectEntryQuery>(
		graphql`
			query UserSegmentationRedirectEntryQuery($accountId: ID!, $cloudId: ID!) @preloadable {
				...UserSegmentationRedirect_fragment
			}
		`,
		userSegQueryRef,
	);

	return (
		<ContextualAnalyticsData sourceName="globalRedirect">
			<UserSegmentationRedirect queryRef={queryRef} />
		</ContextualAnalyticsData>
	);
};

export default UserSegmentationRedirectEntry;
